<style src="./DocumentUpload.scss" lang="scss"></style>
<template>
  <section class="form-box document-upload">
    <h4 class="title">Insira um novo Documento</h4>

    <select
      class="cp1-small-select field"
      v-model="form.documentTypeId">
      <option value="">SELECIONA O TIPO DE DOCUMENTO</option>
      <option
        v-for="(document, documentIdx) in documentList"
        :key="documentIdx"
        :value="document._id">{{ document.title }}</option>
    </select>

    <div
      class="description"
      v-if="stepDescription">
      <h3 class="steptitle">Descrição do arquivo</h3>
      <p class="stepdescription">Utiliza os campos abaixo para dar mais detalhes sobre o arquivo a ser guardado</p>
      <textarea
        type="text"
        v-model="form.description"
        placeholder="Breve descrição do arquivo"
        class="cp1-small-textbox field textarea">
      </textarea>

      <component
        v-for="(componentType, componentIdx) in form.documentFieldsForm"
        class="field"
        :is="componentType.inputType"
        :key="componentIdx"
        :label="componentType.caption"
        v-model="componentType.value" />

      <div class="drop-zone-container">
        <div
          class="drop-zone"
          @dragover="isDragOver"
          @dragenter="isDragOver"
          @dragleave="isDragLeave"
          @dragend="isDragLeave"
          @drop="isDrop"
          :class="{'drop-zone-over': dragOverClass}"
          v-show="uploadStage === 'UPLOAD'">
          <label class="input-label">
            <input
              type="file"
              class="input-file"
              accept="*.*"
              ref="inputFile"
              @change="isChoosed">

            <icon-upload class="icon"/>
            <h3>Respositório de arquivo</h3>
            <h5>Arraste o arquivo aqui ou clique para escolher</h5>
          </label>
        </div>

        <div
          class="wait"
          v-show="uploadStage === 'WAIT'">
          <icon-wait class="icon" />
          <h3>Processando o arquivo</h3>
          <h5>Aguarde...</h5>
        </div>
        <div
          class="inserted-file"
          v-show="uploadStage === 'SELECTED'">
          <icon-check class="icon" />
          <h3>Arquivo selecionado</h3>
          <h5>Está tudo pronto para ser salvo.</h5>
        </div>
      </div>
    </div>

    <div class="commands">
      <button
        :disabled="step.isCancelUploadDisabled"
        type="button"
        class="cp1-small-button cp1-button__ghost cancel"
        @click="cancelUpload">
        Não salvar
      </button>

      <button
        :disabled="step.isSubmitDocumentDisabled"
        type="button"
        class="cp1-small-button cp1-button__success submit"
        @click="submitDocument">
        Salvar Documento
      </button>
    </div>
  </section>
</template>

<script>
import { Cp1Textbox, Cp1Datebox, Cp1Moneybox } from '@/components/primitives'
import { IconUpload, IconWait, IconCheck } from '@/components/primitives/icons'
import FileHandle from './FileHandle'
import { mapGetters } from 'vuex'

let file = null
export default {
  name: 'DocumentUpload',
  components: {
    IconUpload,
    IconWait,
    IconCheck,
    Cp1Textbox,
    Cp1Datebox,
    Cp1Moneybox
  },
  data: () => {
    return {
      dragOverClass: false,
      uploadStage: 'UPLOAD',
      form: {
        description: '',
        documentTypeId: '',
        documentFieldsForm: []
      },
      step: {
        isCancelUploadDisabled: true,
        isSubmitDocumentDisabled: true,
        description: false,
        uploadFile: false
      }
    }
  },
  computed: {
    ...mapGetters({
      documentList: 'DocumentType/LIST'
    }),
    stepDescription () { return this.form.documentTypeId && this.form.documentTypeId.length > 0 }
  },
  watch: {
    'form.documentTypeId' () {
      const documentId = this.form.documentTypeId
      const documents = this.documentList.filter(i => i._id.toString() === documentId)

      let fields = []
      if (documents.length > 0) {
        fields = documents[0].fields.map(i => ({
          ...i,
          value: null
        }))
      }
      this.form.documentFieldsForm = fields
    }
  },
  mounted () {
    this.loadDocumentTypes()
  },
  methods: {
    loadDocumentTypes () {
      this.$store.dispatch('DocumentType/LIST_PAGINATED')
    },
    isDragOver (e) {
      e.preventDefault()
      e.stopPropagation()

      if (!this.dragOverClass) this.dragOverClass = true
    },
    isDragLeave (e) {
      e.preventDefault()
      e.stopPropagation()

      if (this.dragOverClass) this.dragOverClass = false
    },
    isDrop (e) {
      e.preventDefault()
      e.stopPropagation()
      if (this.dragOverClass) this.dragOverClass = false
      file = e.dataTransfer.files[0]
      this.uploadStage = 'SELECTED'
      this.step.isCancelUploadDisabled = false
      this.step.isSubmitDocumentDisabled = false
    },
    isChoosed (e) {
      e.preventDefault()
      e.stopPropagation()
      file = e.target.files[0]
      this.uploadStage = 'SELECTED'
      this.step.isCancelUploadDisabled = false
      this.step.isSubmitDocumentDisabled = false
    },
    async submitDocument () {
      const eventId = this.$route.params.id
      if (this.dragOverClass) this.dragOverClass = false
      this.uploadStage = 'WAIT'
      try {
        if (!this.form.documentTypeId) {
          throw Error()
        }
        await FileHandle(file, eventId, this.form)
        await this.reloadItems()
        this.$toasted.success('Upload realizado com sucesso!')
      } catch (error) {
        this.$toasted.error('Infelizmente não conseguimos subir o arquivo')
      } finally {
        this.uploadStage = 'UPLOAD'
        this.$refs.inputFile.value = null
        this.cleanFields()
      }
    },
    async reloadItems () {
      const payload = {
        eventId: this.$route.params.id
      }
      await this.$store.dispatch('EventDocuments/LIST_BY_EVENT', payload)
    },
    cleanFields () {
      file = null
      this.$refs.inputFile.value = null
      this.form.description = ''
      this.form.documentTypeId = ''
      this.form.documentFieldsForm = []
      this.step.isCancelUploadDisabled = true
      this.step.isSubmitDocumentDisabled = true
      this.uploadStage = 'UPLOAD'
    },
    cancelUpload () {
      this.cleanFields()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-documents/components/document-upload/DocumentUpload.vue